// @ts-ignore

import traverseISODate from '@segment/isodate-traverse';

import { nestedRemoveUndefinedValues } from './util';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const prepareEventContext = <T extends object>(context: T): T => {
	const propertiesWithoutUndefined = nestedRemoveUndefinedValues(context, '$.context');
	return traverseISODate(propertiesWithoutUndefined);
};
